import { Request } from '~src/httpClient/serverApi/requests/Request';
import { ILoginParams } from '~src/sessionManagement/serverApi/types/ILoginParams';

import { IGetSiteSamlLoginInfoResult } from '../../types/saml/IGetSiteSamlLoginInfoResult';

export class GetSiteSamlLoginInfoRequest extends Request<ILoginParams, IGetSiteSamlLoginInfoResult> {
  constructor(params: ILoginParams) {
    super('getSiteSamlLoginInfo', params);
  }
}
